import { render } from "./post-smtp-notification-bar.vue?vue&type=template&id=a0f5f30c&scoped=true"
import script from "./post-smtp-notification-bar.vue?vue&type=script&lang=js"
export * from "./post-smtp-notification-bar.vue?vue&type=script&lang=js"

import "./post-smtp-notification-bar.vue?vue&type=style&index=0&id=a0f5f30c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f5f30c"]])

export default __exports__